import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvcPublicLayoutComponent } from './public-layout.component';

@NgModule({
  declarations: [
    SvcPublicLayoutComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SvcPublicLayoutComponent,
  ],
  providers: [
  ],
})
export class PublicLayoutModule { }
